import React, { Component, Fragment } from 'react';
import { Button, Icon, Modal, Tag, Result, Switch } from 'antd';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DEFINE, { PATHS } from "../../../../../constants/Define";
import * as Func from '../../../../../helpers/functions';
import { withTranslation } from "react-i18next";
import { PageListComponent, HeaderListComponent, ListComponent, FilterDropdown } from "../../../common/component/Index";
import { FlagIcons } from "../../../common/component/TranslateButton";
import Ripple from '../../../common/component/Ripple';
import { getMenuItems, getMenus, syncMenuItems, updateMenu, updateMenuItem } from '../../../../../actions/fnbAction';

const pageSize = 10;
const menuItemPageSize = 50;

class MenuSub extends Component {
    state = {
        filters: {
            PageIndex: 1,
            PageSize: pageSize,
        },
        menuItemFilters: {
            PageIndex: 1,
            PageSize: menuItemPageSize,
        },
        viewMode: 'submenu',
        resolvedMenuId: null,
    };

    componentDidMount() {
        const menuPermissionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.FNB_MENU);

        if (!menuPermissionActions || !menuPermissionActions.allowView) {
            return;
        }

        this.loadSubMenus(this.props.match.params.id);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.match.params.id !== this.props.match.params.id) {
            this.loadSubMenus(this.props.match.params.id);
            return;
        }

        const currentMenuId = this.props.match.params.id;
        const justResolvedSubMenuRequest =
            prevProps.loading && !this.props.loading && this.state.resolvedMenuId !== currentMenuId;

        if (justResolvedSubMenuRequest) {
            const hasSubMenus = (this.props.menus || []).length > 0;

            if (hasSubMenus) {
                this.setState({
                    viewMode: 'submenu',
                    resolvedMenuId: currentMenuId,
                });
                return;
            }

            const menuItemPermissionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.FNB_MENU_ITEM);
            if (!menuItemPermissionActions || !menuItemPermissionActions.allowView) {
                this.setState({
                    viewMode: 'menu-item-forbidden',
                    resolvedMenuId: currentMenuId,
                });
                return;
            }

            this.loadMenuItems(currentMenuId);
        }
    }

    loadSubMenus = (menuId) => {
        const nextFilters = {
            PageIndex: 1,
            PageSize: pageSize,
            ParentId: menuId,
        };
        this.setState({
            filters: nextFilters,
            menuItemFilters: {
                PageIndex: 1,
                PageSize: menuItemPageSize,
                MenuId: menuId,
            },
            viewMode: 'submenu',
            resolvedMenuId: null,
        });
        this.props.actions.getMenus(nextFilters);
    };

    loadMenuItems = (menuId, overrides = {}) => {
        const nextFilters = Func.removeObjectNull({
            ...this.state.menuItemFilters,
            ...overrides,
            MenuId: menuId,
        });
        this.setState({
            menuItemFilters: nextFilters,
            viewMode: 'menu-item',
            resolvedMenuId: menuId,
        });
        this.props.actions.getMenuItems(nextFilters);
    };

    fetchMenus = (filters) => {
        this.setState({ filters });
        this.props.actions.getMenus(filters);
    };

    buildFilters = (pagination, filters, sorter) => {
        const currentFilters = this.state.filters || {};
        const hasNameKey = Object.prototype.hasOwnProperty.call(filters || {}, 'name');
        const hasCodeKey = Object.prototype.hasOwnProperty.call(filters || {}, 'code');
        const hasStatusKey = Object.prototype.hasOwnProperty.call(filters || {}, 'isActive');
        const hasLevelKey = Object.prototype.hasOwnProperty.call(filters || {}, 'level');
        const nameFilterRaw = filters?.name;
        const codeFilterRaw = filters?.code;
        const statusFilterRaw = filters?.isActive;
        const levelFilterRaw = filters?.level;
        const nameFilter = Array.isArray(nameFilterRaw) ? nameFilterRaw[0] : undefined;
        const codeFilter = Array.isArray(codeFilterRaw) ? codeFilterRaw[0] : undefined;
        const statusFilter = Array.isArray(statusFilterRaw) ? statusFilterRaw[0] : undefined;
        const levelFilter = Array.isArray(levelFilterRaw) ? levelFilterRaw[0] : undefined;
        const nameEmpty = typeof nameFilter === 'string' && nameFilter.trim() === '';
        const codeEmpty = typeof codeFilter === 'string' && codeFilter.trim() === '';
        const levelEmpty = levelFilter === '' || levelFilter === null || levelFilter === undefined;
        const nameCleared =
            (hasNameKey && (nameFilterRaw === null || nameFilterRaw === undefined)) ||
            (hasNameKey && Array.isArray(nameFilterRaw) && nameFilterRaw.length === 0) ||
            nameEmpty;
        const codeCleared =
            (hasCodeKey && (codeFilterRaw === null || codeFilterRaw === undefined)) ||
            (hasCodeKey && Array.isArray(codeFilterRaw) && codeFilterRaw.length === 0) ||
            codeEmpty;
        const statusCleared = hasStatusKey && Array.isArray(statusFilterRaw) && statusFilterRaw.length === 0;
        const levelCleared =
            (hasLevelKey && (levelFilterRaw === null || levelFilterRaw === undefined)) ||
            (hasLevelKey && Array.isArray(levelFilterRaw) && levelFilterRaw.length === 0) ||
            levelEmpty;
        const searchTerm = nameCleared || codeCleared
            ? undefined
            : nameFilter !== undefined && !nameEmpty
                ? nameFilter
                : codeFilter !== undefined && !codeEmpty
                    ? codeFilter
                    : currentFilters.SearchTerm;
        const isActive = statusCleared ? undefined : (statusFilter !== undefined ? statusFilter : currentFilters.IsActive);
        const levelParsed = levelFilter !== undefined && levelFilter !== '' ? Number(levelFilter) : undefined;
        const levelValue = levelCleared
            ? undefined
            : levelFilter !== undefined && levelFilter !== '' && !Number.isNaN(levelParsed)
                ? levelParsed
                : currentFilters.Level;
        const orderBy = sorter?.order ? sorter.field : undefined;
        const orderByDesc = sorter?.order ? sorter.order === 'descend' : undefined;
        const pageIndex = pagination?.current || currentFilters.PageIndex || 1;
        const pageSizeValue = pagination?.pageSize || currentFilters.PageSize || pageSize;
        const changedFilters =
            searchTerm !== currentFilters.SearchTerm ||
            isActive !== currentFilters.IsActive ||
            levelValue !== currentFilters.Level ||
            orderBy !== currentFilters.OrderBy ||
            orderByDesc !== currentFilters.OrderByDesc;
        return Func.removeObjectNull({
            PageIndex: changedFilters ? 1 : pageIndex,
            PageSize: pageSizeValue,
            ParentId: currentFilters.ParentId,
            SearchTerm: searchTerm,
            IsActive: isActive,
            Level: levelValue,
            OrderBy: orderBy,
            OrderByDesc: orderByDesc,
        });
    };

    handleChange = (pagination, filters, sorter) => {
        const nextFilters = this.buildFilters(pagination, filters, sorter);
        this.fetchMenus(nextFilters);
    }

    buildUpdateStatusPayload = (record, isActive) => ({
        ...record,
        isActive,
        status: isActive ? 1 : 0,
    });

    handleUpdateStatus = (record, checked) => {
        const { t } = this.props;
        if (!record?.id) {
            return;
        }

        Modal.confirm({
            title: t('item.fnb.menu.status'),
            content: checked
                ? 'Bạn có chắc chắn muốn kích hoạt menu này?'
                : 'Bạn có chắc chắn muốn tắt menu này?',
            okText: t('action.confirm') || 'Xác nhận',
            cancelText: t('action.cancel') || 'Hủy',
            onOk: () => {
                this.props.actions.updateMenu({
                    id: record.id,
                    updatePayload: this.buildUpdateStatusPayload(record, checked),
                    filters: this.state.filters,
                });
            },
        });
    };

    handleMenuItemChange = (pagination) => {
        const currentFilters = this.state.menuItemFilters || {};
        const filters = pagination?.filters || {};
        const hasNameKey = Object.prototype.hasOwnProperty.call(filters || {}, 'name');
        const hasCodeKey = Object.prototype.hasOwnProperty.call(filters || {}, 'code');
        const nameFilterRaw = filters?.name;
        const codeFilterRaw = filters?.code;
        const nameFilter = Array.isArray(nameFilterRaw) ? nameFilterRaw[0] : undefined;
        const codeFilter = Array.isArray(codeFilterRaw) ? codeFilterRaw[0] : undefined;
        const nameEmpty = typeof nameFilter === 'string' && nameFilter.trim() === '';
        const codeEmpty = typeof codeFilter === 'string' && codeFilter.trim() === '';
        const nameCleared = (hasNameKey && Array.isArray(nameFilterRaw) && nameFilterRaw.length === 0) || nameEmpty;
        const codeCleared = (hasCodeKey && Array.isArray(codeFilterRaw) && codeFilterRaw.length === 0) || codeEmpty;
        const searchTerm = nameCleared || codeCleared
            ? undefined
            : nameFilter !== undefined && !nameEmpty
                ? nameFilter
                : codeFilter !== undefined && !codeEmpty
                    ? codeFilter
                    : currentFilters.SearchTerm;

        const changedFilters = searchTerm !== currentFilters.SearchTerm;

        this.loadMenuItems(this.props.match.params.id, {
            PageIndex: changedFilters ? 1 : (pagination?.current || 1),
            PageSize: pagination?.pageSize || menuItemPageSize,
            SearchTerm: searchTerm,
        });
    }

    handleUpdateMenuItem = (record, checked) => {
        if (!record?.id) {
            return;
        }

        this.props.actions.updateMenuItem({
            updatePayload: {
                id: record.id,
                closeItemInternal: checked,
            },
            filters: this.state.menuItemFilters,
        });
    }

    onSyncMenuItems = () => {
        const { t, location } = this.props;
        const outletId = location?.state?.outletId;
        const outletPropertyId = location?.state?.outletPropertyId;

        if (!outletId) {
            return;
        }

        Modal.confirm({
            title: t('action.syncMenuItems') || 'Sync menu items',
            content: t('notification.confirmSyncData') || 'Bạn có chắc chắn muốn đồng bộ dữ liệu menu cho outlet này?',
            okText: t('action.confirm') || 'Xác nhận',
            cancelText: t('action.cancel') || 'Hủy',
            onOk: () => {
                this.props.actions.syncMenuItems({
                    outletId,
                    propertyId: outletPropertyId,
                    filters: this.state.menuItemFilters,
                });
            },
        });
    };

    formatOutlets = (outlets, record) => {
        const outletList = Array.isArray(outlets) ? outlets : [];
        const names = outletList
            .map((outlet) => outlet?.name || outlet?.code || outlet?.id)
            .filter(Boolean);
        if (names.length) {
            return names.join(', ');
        }
        return record?.fnbOutletId || record?.outletId || record?.outlet || '';
    };

    renderMenuItemTags = (tags = []) => {
        if (!Array.isArray(tags) || tags.length === 0) {
            return '-';
        }
        return tags.map((tag) => (
            <Tag key={tag.id || tag.name} color="blue">
                {tag.name}
            </Tag>
        ));
    };

    renderBooleanTag = (value, activeLabel, inactiveLabel) => (
        value
            ? <Tag color="red">{activeLabel}</Tag>
            : <Tag color="green">{inactiveLabel}</Tag>
    );

    render() {
        const {
            t,
            match,
            location,
            menus,
            loading,
            menusPagination,
            menuItems,
            menuItemsLoading,
            menuItemsPagination,
            menuItemSyncing,
        } = this.props;
        const { filters, menuItemFilters, viewMode } = this.state;
        const menuName = location?.state?.menuName || `Menu ${match.params.id}`;
        const outletId = location?.state?.outletId;
        const outletPropertyId = location?.state?.outletPropertyId;
        const menuPermissionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.FNB_MENU);

        if (!menuPermissionActions || !menuPermissionActions.allowView) {
            return (
                <Result
                    status="403"
                    title="403"
                    subTitle={t('item.fnb.menu.unauthorized') || "Bạn không có quyền truy cập vào khu vực này"}
                />
            );
        }

        if (viewMode === 'menu-item-forbidden') {
            return (
                <Result
                    status="403"
                    title="403"
                    subTitle={t('item.fnb.menuItem.unauthorized') || "Bạn không có quyền truy cập vào khu vực này"}
                />
            );
        }

        const subMenuColumns = [
            {
                title: t('item.fnb.menu.code'),
                dataIndex: 'code',
                key: 'code',
                sorter: true,
            },
            {
                title: t('item.fnb.menu.name'),
                dataIndex: 'name',
                key: 'name',
                sorter: true,
                filteredValue: filters.SearchTerm ? [filters.SearchTerm] : null,
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    />
                ),
                filterIcon: filtered => (
                    <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
                render: (text, record) => (
                    <Link
                        to={{
                            pathname: Func.getPathWithParams(PATHS.FNB.MENU_MANAGER.SUB_MENU.path, { id: record.id }),
                            state: {
                                menuName: record.name,
                                outletId,
                                outletPropertyId,
                            },
                        }}
                        className="colorPrimary"
                    >
                        {text}
                    </Link>
                )
            },
            {
                title: 'Level',
                dataIndex: 'level',
                key: 'level',
                sorter: true,
                filteredValue: filters.Level !== undefined ? [filters.Level] : null,
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                        inputType="number"
                        inputProps={{ min: 0, step: 1 }}
                    />
                ),
                filterIcon: filtered => (
                    <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
            },
            {
                title: t('item.fnb.menu.outlet'),
                dataIndex: 'outlets',
                key: 'outlets',
                render: (outlets, record) => this.formatOutlets(outlets, record),
            },
            {
                title: t('item.fnb.menu.translations'),
                dataIndex: 'translations',
                key: 'translations',
                render: (translations) => <FlagIcons languages={translations || []} />
            },
            {
                title: t('item.fnb.menu.status'),
                dataIndex: 'isActive',
                key: 'isActive',
                filters: [
                    { value: true, text: t('item.fnb.menu.active') },
                    { value: false, text: t('item.fnb.menu.inactive') },
                ],
                filterMultiple: false,
                filteredValue: filters.IsActive !== undefined ? [filters.IsActive] : null,
                render: (isActive, record) => {
                    const active =
                        typeof isActive === 'boolean' ? isActive : Boolean(record.status);
                    const canUpdate = menuPermissionActions && menuPermissionActions.allowUpdate;
                    return (
                        <Switch
                            checked={active}
                            disabled={!canUpdate || this.props.menuUpdateLoading}
                            checkedChildren={t('item.fnb.menu.active')}
                            unCheckedChildren={t('item.fnb.menu.inactive')}
                            onChange={(checked) => this.handleUpdateStatus(record, checked)}
                        />
                    );
                }
            },
            {
                title: t('action.action'),
                key: 'action',
                align: 'right',
                render: (text, record) => (
                    <Link
                        to={{
                            pathname: Func.getPathWithParams(PATHS.FNB.MENU_MANAGER.DETAIL.path, {
                                id: record.id,
                            }),
                            state: { menuName },
                        }}
                    >
                        <Icon type="form" className="fs20 colorPrimary" />
                    </Link>
                )
            },
        ];

        const menuItemColumns = [
            {
                title: t('item.fnb.menuItem.code'),
                dataIndex: 'code',
                key: 'code',
            },
            {
                title: t('item.fnb.menuItem.name'),
                dataIndex: 'name',
                key: 'name',
                filteredValue: menuItemFilters.SearchTerm ? [menuItemFilters.SearchTerm] : null,
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    />
                ),
                filterIcon: filtered => (
                    <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
            },
            {
                title: t('item.fnb.menuItem.tags'),
                dataIndex: 'tags',
                key: 'tags',
                render: (tags) => this.renderMenuItemTags(tags),
            },
            {
                title: t('item.fnb.menuItem.closeItem'),
                dataIndex: 'closeItem',
                key: 'closeItem',
                render: (value) => this.renderBooleanTag(
                    value,
                    t('item.fnb.menuItem.active'),
                    t('item.fnb.menuItem.inactive')
                ),
            },
            {
                title: t('item.fnb.menuItem.closeItemInternal'),
                dataIndex: 'closeItemInternal',
                key: 'closeItemInternal',
                render: (value, record) => {
                    const menuItemPermissionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.FNB_MENU_ITEM);
                    const canUpdate = menuItemPermissionActions && menuItemPermissionActions.allowUpdate;
                    const isChecked = Boolean(value);

                    return (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <Switch
                                checked={isChecked}
                                disabled={!canUpdate || this.props.menuItemUpdating}
                                onChange={(checked) => this.handleUpdateMenuItem(record, checked)}
                            />
                            <span>
                                {isChecked
                                    ? t('item.fnb.menuItem.active')
                                    : t('item.fnb.menuItem.inactive')}
                            </span>
                        </div>
                    );
                },
            },
            {
                title: t('item.fnb.menuItem.salePrice'),
                dataIndex: 'salePrice',
                key: 'salePrice',
                align: 'right',
                render: (value) => Func.formatMoney(value || 0),
            },
        ];

        return (
            <Fragment>
                <PageListComponent>
                    <HeaderListComponent
                        path={match.path}
                        titleHeader={menuName}
                        extraBreadcrumbs={[
                            { title: t('navigation.menu'), path: PATHS.FNB.MENU_MANAGER.LIST.path },
                            { title: menuName },
                        ]}
                        componentRight={
                            viewMode === 'menu-item' && outletId ? (
                                <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                    <Button
                                        icon="sync"
                                        className="btn btn-primary"
                                        loading={menuItemSyncing}
                                        onClick={this.onSyncMenuItems}
                                    >
                                        {t('action.syncMenuItems') || 'Sync menu items'}
                                    </Button>
                                </Ripple>
                            ) : null
                        }
                    />
                    <ListComponent
                        tableKey="menu-sub-list"
                        classChildren="p-0"
                        classParent="m-0"
                        rowKey={(record, index) => record.id || record.menuItemId || index}
                        loading={{ spinning: viewMode === 'menu-item' ? menuItemsLoading : loading, size: "large" }}
                        dataSource={viewMode === 'menu-item' ? (menuItems || []) : (menus || [])}
                        columns={viewMode === 'menu-item' ? menuItemColumns : subMenuColumns}
                        onChange={(pagination, tableFilters, sorter) => (
                            viewMode === 'menu-item'
                                ? this.handleMenuItemChange({ ...pagination, filters: tableFilters }, tableFilters, sorter)
                                : this.handleChange(pagination, tableFilters, sorter)
                        )}
                        pagination={{
                            total: viewMode === 'menu-item'
                                ? (menuItemsPagination?.totalCount || 0)
                                : (menusPagination?.totalCount || 0),
                            totalPage: viewMode === 'menu-item'
                                ? (menuItemsPagination?.totalPage || 0)
                                : (menusPagination?.totalPage || 0),
                            current: viewMode === 'menu-item'
                                ? (menuItemFilters.PageIndex || 1)
                                : (filters.PageIndex || 1),
                            pageSize: viewMode === 'menu-item'
                                ? (menuItemFilters.PageSize || menuItemPageSize)
                                : (filters.PageSize || pageSize),
                        }}
                    />
                </PageListComponent>
            </Fragment>
        );
    }

}

const mapStateToProps = (state) => ({
    menus: state.fnbReducer.menus,
    menusPagination: state.fnbReducer.menusPagination,
    menuItems: state.fnbReducer.menuItems,
    menuItemsPagination: state.fnbReducer.menuItemsPagination,
    menuItemsLoading: state.fnbReducer.menuItemsLoading,
    menuItemUpdating: state.fnbReducer.menuItemUpdating,
    menuItemSyncing: state.fnbReducer.menuItemSyncing,
    menuUpdateLoading: state.fnbReducer.menuUpdateLoading,
    loading: state.fnbReducer.loading,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            getMenus,
            getMenuItems,
            syncMenuItems,
            updateMenu,
            updateMenuItem,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(MenuSub));
